import AdviceFooter from './AdviceFooter'

export default AdviceFooter
